import { useQuery } from "@tanstack/react-query";

import UserService from "services/User";

export function useUserSettings() {
  return useQuery({
    queryKey: ["user-settings"],
    queryFn: () => UserService.getUserSettings(),
  });
}
